import * as THREE from 'three';
import type { GameScene } from '../core/Scene';

export class Grid {
  private readonly helper: THREE.GridHelper;

  constructor(size: number, divisions: number, color: number = 0x444466) {
    this.helper = new THREE.GridHelper(size, divisions, color, color);
    // Raise slightly to avoid z-fighting with the ground plane
    this.helper.position.y = 0.001;
  }

  setVisible(visible: boolean): void {
    this.helper.visible = visible;
  }

  addTo(scene: GameScene): void {
    scene.add(this.helper);
  }

  dispose(): void {
    this.helper.geometry.dispose();
    if (Array.isArray(this.helper.material)) {
      this.helper.material.forEach((m) => m.dispose());
    } else {
      this.helper.material.dispose();
    }
  }
}
